import type { ReactElement } from 'react';
import './Spinner.css';

export function Spinner(): ReactElement {
  return <div className="criipto-eid-loader"></div>;
}
